import React, { useContext } from 'react';
import { styled, useStyletron } from 'baseui'
import { Theme } from 'baseui/theme';
import { context } from './ThemeSwitchContext';
import { TYPOGRAPHY_SIZE } from './themes';

const AccessibilityButton = (type: string, theme: Theme) => ({
  FONT_NORMAL: {
    fontSize: '0.75rem',
    backgroundColor: 'transparent',
    border: '0px',
    color: theme.colors.primaryA
  },
  FONT_LARGE: {
    fontSize: '1rem',
    backgroundColor: 'transparent',
    border: '0px',
    color: theme.colors.primaryA
  },
  FONT_XLARGE: {
    fontSize: '1.25rem',
    backgroundColor: 'transparent',
    border: '0px',
    color: theme.colors.primaryA
  },
  CONTRAST_NORMAL: {
    border: '1px solid #000',
    color: '#000',
    backgroundColor: '#fff'
  },
  CONTRAST_BW: {
    border: '1px solid #fff',
    color: '#fff',
    backgroundColor: '#000'
  },
  CONTRAST_YB: {
    border: '1px solid #000',
    color: '#ffff00',
    backgroundColor: '#000'
  },
  CONTRAST_BY: {
    border: '1px solid #000',
    color: '#000',
    backgroundColor: '#ffff00'
  },
} as any)[type]

const WidgetButton = styled<{ $type: string }, 'button'>('button', ({ $theme, $type}) => ({
  ...$theme.typography.ParagraphMedium,
  padding: '0.1rem 0.2rem',
  margin: '0 0.2rem',
  ...AccessibilityButton($type, $theme)

}))
export const ThemeSwitcher = ({ style }: any) => {
  const [css] = useStyletron()
  const { updateTheme, updateTypography } = useContext(context)

  return (
  <div className={css(style || {})}>
    <WidgetButton title='Zmień wielkość czcionki na normalną' $type='FONT_NORMAL' onClick={() => updateTypography(TYPOGRAPHY_SIZE.normal)}>A</WidgetButton>
    <WidgetButton title='Zmień wielkość czcionki na większą' $type='FONT_LARGE' onClick={() => updateTypography(TYPOGRAPHY_SIZE.large)}>A</WidgetButton>
    <WidgetButton title='Zmień wielkość czcionki na dużą' $type='FONT_XLARGE' onClick={() => updateTypography(TYPOGRAPHY_SIZE.xlarge)}>A</WidgetButton>

    <WidgetButton title='Kontrast domyślny' $type='CONTRAST_NORMAL' onClick={() => updateTheme('LIGHT')}>A</WidgetButton>
    <WidgetButton title='Kontrast czarno-biały' $type='CONTRAST_BW' onClick={() => updateTheme('BLACK_WHITE')}>A</WidgetButton>
    <WidgetButton title='Kontrast czarno-żółty' $type='CONTRAST_BY' onClick={() => updateTheme('BLACK_YELLOW')}>A</WidgetButton>
    <WidgetButton title='Kontrast żółto-czarny' $type='CONTRAST_YB' onClick={() => updateTheme('YELLOW_BLACK')}>A</WidgetButton>
  </div>
  )
}